import FancyIcon, { FancyIconProps as _FancyIconProps } from './FancyIcon';

export { FancyIcon };
export type FancyIconProps = _FancyIconProps;
